import { useStaticQuery, graphql } from 'gatsby';
import { get } from 'lodash-es';

const Q = graphql`
  {
    allMarkdownRemark(
      filter: {
        frontmatter: {
          templateKey: { eq: "blog-post" }
          published: { eq: true }
        }
      }
    ) {
      group(field: frontmatter___tags) {
        fieldValue
      }
    }
  }
`;

const PostCategoriesDataProvider = () => {
  const data = useStaticQuery(Q);
  const tags = get(data, 'allMarkdownRemark.group', []).map(c =>
    c.fieldValue.toLowerCase()
  );
  return ['all', ...tags.sort()]
};

export default PostCategoriesDataProvider;
